import React, { useState } from "react";
import { useExport } from "@pankod/refine-core";
import {
  List,
  useTable,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { ISearch } from "type";

export const BingxBalanceList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });

  const rows = tableProps.dataSource?.map((row) => ({
    ...row,
    id: row.bot_subscription_id + row.snapped_at,
  }));

  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "bot_subscription_id",
        title: "Bot-subscription Id",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "snapped_at",
        title: "Snapped At",
        width: 250,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "asset",
        title: "Asset",
        width: 130,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "balance",
        title: "Balance",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "equity",
        title: "Equity",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "unrealized_profit",
        title: "Unrealized profit",
        width: 110,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "realised_profit",
        title: "Realised Profit",
        type: "number",
        width: 110,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "available_margin",
        title: "Available margin",
        type: "number",
        width: 110,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "used_margin",
        title: "Used Margin",
        type: "number",
        width: 110,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "freeze_margin",
        title: "freeze margin",
        type: "number",
        width: 110,
        align: "center",
        headerAlign: "center",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        dataSource={rows}
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
